<template>
  <h1 class="my-4">Input Mapper</h1>
</template>

 <script>
export default {};
</script>
 
 <style>
</style>

 



// WEBPACK FOOTER //
// src/components/Header.vue